/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_TICKET_QUERY,
  ADD_TICKET_QUERY,
  ADD_LABEL,
  DELETE_TICKET_QUERY,
  LOAD_PRIORITY_RECORDS_META_DATA,
  // LOAD_SUBLABEL_META_DATA,
  ADD_SUB_LABEL,
  LOAD_SUBLABEL_META_DATA,
  LOAD_EMPLOYEE_LABELS,
  LOAD_EMPLOYEE_SUB_LABELS,
  LOAD_TICKET_NOTIFICATIONS,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadTicketQuery,
  loadTicketQueryError,
  loadTicketQuerySuccess,
  addTicketQueryError,
  addTicketQuerySuccess,
  addTicketQuery,
  addLabelSuccess,
  addLabelError,
  deleteTicketQuerySuccess,
  deleteTicketQueryError,
  deleteTicketQuery,
  loadPriorityRecordsMetaDataSuccess,
  loadPriorityRecordsMetaDataError,
  addLabel,
  addSubLabelSuccess,
  addSubLabelError,
  addSubLabel,
  loadSubLabelDetails,
  loadSubLabelDetailsSuccess,
  loadSubLabelDetailsError,
  loadEmployeeLabels,
  loadEmployeeLabelsSuccess,
  loadEmployeeLabelsError,
  loadEmployeeSubLabels,
  loadEmployeeSubLabelsSuccess,
  loadEmployeeSubLabelsError,
  loadTicketNotifications,
  loadTicketNotificationsSuccess,
  loadTicketNotificationsError,
  // loadSubLabelMetaData,
  // loadSubLabelMetaDataSuccess,
  // loadSubLabelMetaDataError,
  // loadSubLabelMetaDataSuccess,
  // loadSubLabelMetaDataError,
  // loadSubLabelMetaData,
} from "./actions"

import {
  loadTicketQueryDetails,
  loadRecordsMetaData,
  addTicketQueryDetails,
  deleteTicketQueryDetails,
  loadPriorityMetaDataDetails,
  addLabelDetails,
  addSubLabelDetails,
  loadSubLabelDetailsList,
  loadEmployeeLabelsDetails,
  loadEmployeeSubLabelsDetails,
  loadTicketNotificationsDetails,
  // loadSubLabelMetaDataDetails,
  // loadSubLabelMetaDataDetails,
} from "./remotes"

function* loadTicketQueryDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_TICKET_QUERY),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadTicketQuery(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTicketQueryDetails, searchvalue)
        // console.log("api result is", result)

        if (result) {
          yield put(loadTicketQuerySuccess(result.data))
          // console.log(result.data)
        } else {
          yield put(loadTicketQuerySuccess([]))
          yield put(loadTicketQueryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadTicketQuerySuccess([]))
        yield put(
          loadTicketQueryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadTicketNotificationsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_TICKET_NOTIFICATIONS),
    })

    const { explicitLoad } = load

    const { notitications } = explicitLoad || {}
    yield put(loadTicketNotifications(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTicketNotificationsDetails, notitications)
        // console.log("api result is", result)

        if (result) {
          yield put(loadTicketNotificationsSuccess(result.data))

          // console.log(result.data, "saga result")
        } else {
          yield put(loadTicketNotificationsSuccess([]))
          yield put(loadTicketNotificationsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadTicketNotificationsSuccess([]))
        yield put(
          loadTicketNotificationsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadSubLabelDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_SUBLABEL_META_DATA),
    })

    const { explicitLoad } = load

    const { record } = explicitLoad || {}
    yield put(loadSubLabelDetails(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSubLabelDetailsList, record)
        // console.log("api result is", result)

        if (result) {
          yield put(loadSubLabelDetailsSuccess(result.data))
          // console.log(result.data)
        } else {
          yield put(loadSubLabelDetailsSuccess([]))
          yield put(loadSubLabelDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadSubLabelDetailsSuccess([]))
        yield put(
          loadSubLabelDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadEmployeeLabelDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE_LABELS),
    })

    const { explicitLoad } = load

    const { record } = explicitLoad || {}
    yield put(loadEmployeeLabels(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeLabelsDetails, record)
        // console.log("api result is", result)

        if (result) {
          yield put(loadEmployeeLabelsSuccess(result.data))
          // console.log(result.data)
        } else {
          yield put(loadEmployeeLabelsSuccess([]))
          yield put(loadEmployeeLabelsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEmployeeLabelsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadEmployeeSubLabelDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE_SUB_LABELS),
    })

    const { explicitLoad } = load

    const { record } = explicitLoad || {}
    yield put(loadEmployeeSubLabels(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeSubLabelsDetails, record)
        // console.log("api result is", result)

        if (result) {
          yield put(loadEmployeeSubLabelsSuccess(result.data))
          // console.log(result.data)
        } else {
          yield put(loadEmployeeSubLabelsSuccess([]))
          yield put(loadEmployeeSubLabelsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEmployeeSubLabelsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const label = yield call(loadRecordsMetaData, "all_lable", "post")
      const newLabel = yield call(loadRecordsMetaData, "ticket_label", "post", {
        status: "active",
      })
      const ticket = yield call(loadRecordsMetaData, "ticket_group", "post", {
        status: "active",
      })
      let recordsMetaData = {
        labelData:
          (label &&
            label.data &&
            label.data.length > 0 &&
            label.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.lable,
                    colorCode: c.colorCode,
                    subLabel: c.subLableName,
                    subLabelId: c.subLable,
                    value: c._id,
                  }
                )
              )) ||
          (label &&
            label.length > 0 &&
            label.map((c) =>
              Object.assign(
                {},
                {
                  label: c.lable,
                  colorCode: c.colorCode,
                  subLabel: c.subLableName,
                  subLabelId: c.subLable,
                  value: c._id,
                }
              )
            )) ||
          [],
        newLabelOptions:
          (newLabel &&
            newLabel.data &&
            newLabel.data.length > 0 &&
            newLabel.data.map((c) =>
              Object.assign(
                {},
                {
                  label: c.labelName,
                  value: c._id,
                }
              )
            )) ||
          [],
        ticketGroupOptions:
          (ticket &&
            ticket.data &&
            ticket.data.length > 0 &&
            ticket.data.map((c) =>
              Object.assign(
                {},
                {
                  label: c.groupName,
                  value: c._id,
                  employeeId: c.employeeId,
                }
              )
            )) ||
          [],
      }
      console.log(recordsMetaData, "my details")
      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* loadPriorityMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_PRIORITY_RECORDS_META_DATA),
    })

    try {
      const priority = yield call(
        loadPriorityMetaDataDetails,
        "priority",
        "post"
      )
      const processStatus = yield call(
        loadRecordsMetaData,
        "all_process_status",
        "post"
      )
      let priorityMetaData = {
        priorityOptions:
          (priority &&
            priority.data &&
            priority.data.length > 0 &&
            priority.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.priority,
                    colorCode: c.colorCode,
                    shortCode: c.shortCode,
                    value: c._id,
                  }
                )
              )) ||
          (priority &&
            priority.length > 0 &&
            priority.map((c) =>
              Object.assign(
                {},
                {
                  label: c.priority,
                  colorCode: c.colorCode,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p._id,
                    processStatusId: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
      }
      console.log(priorityMetaData, "my details")
      yield put(loadPriorityRecordsMetaDataSuccess(priorityMetaData))
    } catch (error) {
      yield put(
        loadPriorityRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
// add clearance

function* addTicketQueryDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(ADD_TICKET_QUERY),
    })

    const { explicitLoad } = load

    const { ticketQuery } = explicitLoad || {}
    yield put(addTicketQuery(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(addTicketQueryDetails, ticketQuery)
        // console.log("api result is", result)

        if (result) {
          yield put(addTicketQuerySuccess(result.data))
          // console.log(result.data)
        } else {
          yield put(addTicketQuerySuccess([]))
          yield put(addTicketQueryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(addTicketQuerySuccess([]))
        yield put(
          addTicketQueryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* updateLabelDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(ADD_LABEL),
    })

    const { explicitLoad } = load

    const { labelDetails } = explicitLoad || {}
    yield put(addLabel(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(addLabelDetails, labelDetails)
        // console.log("api result is", result)

        if (result) {
          yield put(addLabelSuccess(result.data))
          // console.log(result.data)
        } else {
          yield put(addLabelSuccess([]))
        }
      } catch (error) {
        yield put(
          addLabelError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
function* updateSubLabelDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(ADD_SUB_LABEL),
    })

    const { explicitLoad } = load

    const { subLabelDetails } = explicitLoad || {}
    yield put(addSubLabel(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(addSubLabelDetails, subLabelDetails)
        // console.log("api result is", result)

        if (result) {
          yield put(addSubLabelSuccess(result.data))
          // console.log(result.data)
        } else {
          yield put(addSubLabelSuccess([]))
        }
      } catch (error) {
        yield put(
          addSubLabelError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* deleteTicketQuerySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(DELETE_TICKET_QUERY),
    })

    const { explicitLoad } = load

    const { deleteTicket } = explicitLoad || {}
    yield put(deleteTicketQuery(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(deleteTicketQueryDetails, deleteTicket)
        // console.log("api result is", result)

        if (result) {
          yield put(deleteTicketQuerySuccess(result.data))
          // console.log(result.data)
        } else {
          yield put(deleteTicketQuerySuccess([]))
        }
      } catch (error) {
        yield put(
          deleteTicketQueryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadTicketNotificationsSaga(),
    loadTicketQueryDetailsSaga(),
    addTicketQueryDetailsSaga(),
    updateLabelDetailsSaga(),
    deleteTicketQuerySaga(),
    loadPriorityMetaDataSaga(),
    loadSubLabelDetailsSaga(),
    updateSubLabelDetailsSaga(),
    loadEmployeeLabelDetailsSaga(),
    loadEmployeeSubLabelDetailsSaga(),
  ])
}
